function backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

var goTopBtn = document.querySelectorAll('[data-behaviour="back-to-top"]');

goTopBtn.forEach(goTopBtn => {
    goTopBtn.addEventListener('click', backToTop);
});
